import { API_ROUTES } from '@/constants/apiRoutes';
import { ApiResponse, PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { Commission } from './commissions.types';

export interface CommissionCategoryParams {
  row?: number;
  fetch?: number;
  fromDate?: number;
  toDate?: number;
  createdDate?: number;
  search?: string;
}

export const getCommissions = (client: AxiosInstance) => async (params?: CommissionCategoryParams) => {
  return (
    await client.get<PaginatedApiResponse<Commission[]>>(API_ROUTES.GET_COMMISSION_CATEGORY, {
      params,
    })
  ).data;
};
export const getCommissionDetail = (client: AxiosInstance) => async (categoryId?: string) => {
  return (
    await client.get<ApiResponse<Commission>>(API_ROUTES.GET_COMMISSION_CATEGORY_DETAIL, {
      params: { categoryId: categoryId || '' },
    })
  ).data;
};
export const commissionQueries = {
  all: () => ['commissions'],
  list: (params?: CommissionCategoryParams) =>
    queryFactoryOptions<PaginatedApiResponse<Commission[]>>({
      queryKey: [...commissionQueries.all(), 'list', params],
      queryFn: (client: AxiosInstance) => () => getCommissions(client)(params),
    }),
  detail: (categoryId?: string) =>
    queryFactoryOptions<ApiResponse<Commission>>({
      queryKey: [...commissionQueries.all(), 'detail', categoryId],
      queryFn: (client: AxiosInstance) => () => getCommissionDetail(client)(categoryId),
    }),
};
